<template>
  <path
    d="M21 8.59018V4.00018C21 3.45018 20.55 3.00018 20 3.00018H15.41C14.52 3.00018 14.07 4.08018 14.7 4.71018L16.29 6.30018L6.29 16.3002L4.7 14.7102C4.08 14.0802 3 14.5202 3 15.4102V20.0002C3 20.5502 3.45 21.0002 4 21.0002H8.59C9.48 21.0002 9.93 19.9202 9.3 19.2902L7.71 17.7002L17.71 7.70018L19.3 9.29018C19.92 9.92018 21 9.48018 21 8.59018Z"
  />
</template>
